import React from 'react'
import { Media } from 'react-bootstrap'
import ReactImageFallback from 'react-image-fallback'
import { jt, t } from 'ttag'
import { Link } from 'react-router-dom'

import companiesIcon from '@h2/assets/svg/icons/companies.svg'
import workBasedLearning from '@h2/assets/svg/icons/workBasedLearning.svg'

const ProfileSectionAutoWBL = ({
  section,
  expanded,
  showWhenNoItems = false,
  hideDescription
}) => {
  if ((!section.additional || !section.additional.length) && !showWhenNoItems) {
    return null
  }

  const defaultThumb = s => {
    console.log(s)

    const fallbackImage = s.url?.includes('/company/') ? companiesIcon : workBasedLearning

    //console.log(isOccupation)
    if (s.image) {
      return (
        <ReactImageFallback
          src={s.image}
          fallbackImage={fallbackImage}
          alt={t`Thumbnail for ${s.title}`}
          width={64}
          height={64}
          className="img-rounded"
        />
      )
    }

    if (fallbackImage) {
      return (
        <img
          className="img-rounded"
          width={64}
          height={64}
          src={fallbackImage}
          aria-hidden="true"
          alt={t`Thumbnail for ${s.title}`}
        />
      )
    }

    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">
        <rect fill="#DDDDDD" x="0" y="0" width="64" height="64" rx="6" ry="6" />
        <text
          x="32"
          y="32"
          fontFamily="Verdana"
          fontSize="35"
          textAnchor="middle"
          alignmentBaseline="central">
        </text>
      </svg>
    )
  }
  const companies = <b>{t`companies`}</b>
  const offer = <b>{t`these opportunities`}</b>
  const take = (lst, num) => {
    if (lst && lst.length > num) {
      return lst.slice(0, num)
    }

    return lst
  }

  if (expanded) {
    return (
      <div>
        {section.suppressTitle ? (
          <h4 className="profile-emphasized-heading main-title">{jt`What are some ${companies} that offer ${offer}?`}</h4>
        ) : null}
        {section.additional.map(s => (
          <Media key={`media.${s.url}`}>
            <Media.Left>
              <Link to={s.url}>{defaultThumb(s)}</Link>
            </Media.Left>
            <Media.Body style={{ verticalAlign: 'middle' }}>
              <Media.Heading>
                <Link to={s.url}>{s.title}</Link>
              </Media.Heading>
              {!hideDescription && s.description ? (
                <p dangerouslySetInnerHTML={{ __html: s.description }}></p>
              ) : null}
            </Media.Body>
          </Media>
        ))}
      </div>
    )
  }

  return (
    <div className="with-border" style={{ marginTop: '40px' }}>
      {section.suppressTitle ? (
        <h4 className="profile-emphasized-heading main-title">{jt`What are some ${companies} that offer ${offer}?`}</h4>
      ) : null}
      <ul className="list" style={{ padding: 0 }}>
        {' '}
        {take(
          section.additional.filter(s => !!s.image),
          6
        ).map((s, idx) => (
          <li
            className="item col-xs-2 text-center"
            style={{ listStyle: 'none' }}
            key={`additional-detail-${idx}`}>
            {' '}
            <Link to={s.url}>{defaultThumb(s)}</Link>
          </li>
        ))}{' '}
      </ul>
      <br className="clear" />
    </div>
  )
}

export default ProfileSectionAutoWBL
